import type { AddressRegion } from "@jti/fe-common";

export const getNormalizedRegion = (region: string | AddressRegion | undefined): AddressRegion | undefined => {
  if (!region) return undefined;

  const regionName = typeof region === "string" ? region : region.region;

  if (!regionName) return undefined;

  return {
    region_id: 0,
    region_code: "0",
    region: regionName,
  };
};
